import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e7fe3ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-content text-xl font-bold" }, " Edit Product Catalog Base Cost ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header text-base font-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Information")
], -1))
const _hoisted_3 = { class: "px-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold" }, "Name", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold" }, "Product Code", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold" }, "Category", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold" }, "Overview", -1))
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold mb-3" }, "Feature", -1))
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header font-bold" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Variants")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header font-bold" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Artwork Template")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header font-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mockup")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header font-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Production")
], -1))
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header font-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Shipping")
], -1))
const _hoisted_17 = { class: "" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header font-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Material")
], -1))
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "mt-3 flex items-center justify-between" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode("  Save ")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }),
  /*#__PURE__*/_createTextVNode("  Confirm ")
], -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Are you sure you want to delete catalog ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" ? ")
const _hoisted_30 = { class: "dialog-footer" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_32 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_34 = /*#__PURE__*/_createTextVNode("  Confirm ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_Variants = _resolveComponent("Variants")!
  const _component_DesignTemplate = _resolveComponent("DesignTemplate")!
  const _component_UploadImage = _resolveComponent("UploadImage")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_sectionLayoutContent = _resolveComponent("sectionLayoutContent")!
  const _directive_hoist = _resolveDirective("hoist")!

  return (_openBlock(), _createBlock(_component_sectionLayoutContent, _mergeProps(_ctx.content, {
    backPageTitle: `Back`,
    style: {"overflow":"hidden"}
  }), {
    default: _withCtx(() => [
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            class: "p-2.5 w-full create-catalog"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { md: 24 }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 1,
            class: "create-catalog"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { md: 18 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_card, null, {
                            header: _withCtx(() => [
                              _hoisted_2
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_el_row, { gutter: 20 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 4 }, {
                                      default: _withCtx(() => [
                                        _hoisted_4
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 20 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.catalog.name), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_divider),
                                _createVNode(_component_el_row, { gutter: 20 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 4 }, {
                                      default: _withCtx(() => [
                                        _hoisted_5
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 20 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.catalog.productCode), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_divider),
                                _createVNode(_component_el_row, { gutter: 20 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 4 }, {
                                      default: _withCtx(() => [
                                        _hoisted_6
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 20 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.catalog.categories?.map(item => item.title).join(', ')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_divider),
                                _createVNode(_component_el_row, { gutter: 20 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 4 }, {
                                      default: _withCtx(() => [
                                        _hoisted_7
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, {
                                      span: 20,
                                      style: {"text-align":"justify !important"},
                                      class: "custom-scrollDiv"
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("template", {
                                          innerHTML: _ctx.catalog.description
                                        }, null, 8, _hoisted_8), [
                                          [_directive_hoist]
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_divider),
                                _createVNode(_component_el_row, { gutter: 20 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 24 }, {
                                      default: _withCtx(() => [
                                        _hoisted_9
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, {
                                      span: 24,
                                      style: {"text-align":"justify !important"},
                                      class: "custom-scrollDiv"
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("template", {
                                          innerHTML: _ctx.catalog.description2
                                        }, null, 8, _hoisted_10), [
                                          [_directive_hoist]
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_card, { class: "my-3" }, {
                            header: _withCtx(() => [
                              _hoisted_11
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_Variants, {
                                isAcceptColor: 
                  _ctx.isSubmit &&
                  _ctx.catalog &&
                  _ctx.catalog.colors &&
                  _ctx.catalog.colors.length === 0
                    ? true
                    : false
                ,
                                isAcceptSize: 
                  _ctx.isSubmit &&
                  _ctx.catalog &&
                  _ctx.catalog.sizes &&
                  _ctx.catalog.sizes.length === 0
                    ? true
                    : false
                ,
                                onChangeCostBy: _ctx.changeCostBy,
                                onCallback: _ctx.callbackVariant,
                                colors: _ctx.catalog.colors,
                                sizes: _ctx.catalog.sizes,
                                costBy: _ctx.costBy,
                                values: _ctx.catalog.variants,
                                productCode: _ctx.catalog.productCode,
                                baseCost: _ctx.baseCostId,
                                typeAction: "edit"
                              }, null, 8, ["isAcceptColor", "isAcceptSize", "onChangeCostBy", "onCallback", "colors", "sizes", "costBy", "values", "productCode", "baseCost"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_card, null, {
                            header: _withCtx(() => [
                              _hoisted_12
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_DesignTemplate, {
                                dataSet: _ctx.catalog.designs,
                                onCallback: _ctx.addDesign,
                                onDelDesign: _ctx.delDesign
                              }, null, 8, ["dataSet", "onCallback", "onDelDesign"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 6,
                class: "pl-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, null, {
                    header: _withCtx(() => [
                      _hoisted_13
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_UploadImage, {
                          accept: `image/*`,
                          multiple: true,
                          title: ``,
                          permission: `read`,
                          setData: _ctx.catalog,
                          data: _ctx.catalog.mockupGallery,
                          onCallback: _ctx.callbackMockup
                        }, null, 8, ["setData", "data", "onCallback"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, { class: "my-3" }, {
                    header: _withCtx(() => [
                      _hoisted_14
                    ]),
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("template", {
                        innerHTML: _ctx.catalog.production
                      }, null, 8, _hoisted_15), [
                        [_directive_hoist]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, { class: "my-3" }, {
                    header: _withCtx(() => [
                      _hoisted_16
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("template", {
                          innerHTML: _ctx.catalog.shipping
                        }, null, 8, _hoisted_18), [
                          [_directive_hoist]
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.catalog.material)
                    ? (_openBlock(), _createBlock(_component_el_card, {
                        key: 0,
                        class: "my-3"
                      }, {
                        header: _withCtx(() => [
                          _hoisted_19
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("template", {
                            innerHTML: _ctx.catalog.material
                          }, null, 8, _hoisted_20)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_button, { onClick: _ctx.discard }, {
                        default: _withCtx(() => [
                          _hoisted_23,
                          _hoisted_24
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.updateCatalog
                      }, {
                        default: _withCtx(() => [
                          _hoisted_25,
                          _hoisted_26
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_dialog, {
                modelValue: _ctx.dialog,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialog) = $event)),
                width: "40%"
              }, {
                title: _withCtx(() => [
                  _hoisted_27
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("span", _hoisted_30, [
                    _createVNode(_component_el_button, { onClick: _ctx.cancelDelete }, {
                      default: _withCtx(() => [
                        _hoisted_31,
                        _hoisted_32
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.confirmDelete
                    }, {
                      default: _withCtx(() => [
                        _hoisted_33,
                        _hoisted_34
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _hoisted_28,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.catalog.name), 1),
                    _hoisted_29
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}